/* eslint-disable @typescript-eslint/no-unused-vars */
import type {AppConfiguration} from "./app-configuration-types";
export const C: AppConfiguration = {
    package: 'cleanup',
    menu: 'hidden',
    profile: {
        p_name_col_name: 'Name',
        p_description_col_name: 'Description',
        searchConfiguration: 'default_p_desc',
        locale: 'nl-nl',
        currency: 'EUR',
        taxonomy_builder_only_n_cats: true,
        allowIncompleteTaxonomy: true,

        parentSupplierAltName: 'Normalized Supplier',
    },
}
